import React, { useEffect, useMemo } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Grid, TextField
} from '@mui/material';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import dayjs from 'dayjs';
import EmpSelectbox from '../common/form/autocomplete/EmpSelectbox';

const validationSchema = yup.object({
  usrUuid: yup.string().required('직원을 선택하세요'),
  attendDt: yup.string().required('근무일을 입력하세요'),
  inTm: yup.string().required('출근 시간을 입력하세요'),
});

const AttendInputModal = ({ open, data, onClose, onSave }) => {
  const isEdit = !!data;
  const { user } = useSelector(({ auth }) => ({ user: auth.user }));
  const defaultUsrUuid = useMemo(() => user?.usrUuid || '', [user]);

  const formik = useFormik({
    initialValues: {
      usrUuid: defaultUsrUuid,
      attendDt: dayjs().format('YYYY-MM-DD'),
      inTm: '09:00',
      outTm: '18:00',
      rmk: '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      onSave(values);
    },
  });

  useEffect(() => {
    if (open) {
      if (data) {
        formik.setValues({
          usrUuid: data.usrUuid || '',
          attendDt: data.attendDt ? dayjs(data.attendDt).format('YYYY-MM-DD') : '',
          inTm: data.inTm || '',
          outTm: data.outTm || '',
          rmk: data.rmk || '',
        });
      } else {
        formik.resetForm();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, data]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? '출퇴근 수정' : '출퇴근 등록'}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} sx={{ pt: 1 }}>
          <Grid item xs={12}>
            <EmpSelectbox
              formik={formik}
              name="usrUuid"
              label="직원 *"
              variant="outlined"
              margin="none"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="date"
              label="근무일 *"
              size="small"
              InputLabelProps={{ shrink: true }}
              name="attendDt"
              value={formik.values.attendDt}
              onChange={formik.handleChange}
              error={formik.touched.attendDt && Boolean(formik.errors.attendDt)}
              helperText={formik.touched.attendDt && formik.errors.attendDt}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              type="time"
              label="출근 시간 *"
              size="small"
              InputLabelProps={{ shrink: true }}
              name="inTm"
              value={formik.values.inTm}
              onChange={formik.handleChange}
              error={formik.touched.inTm && Boolean(formik.errors.inTm)}
              helperText={formik.touched.inTm && formik.errors.inTm}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              type="time"
              label="퇴근 시간"
              size="small"
              InputLabelProps={{ shrink: true }}
              name="outTm"
              value={formik.values.outTm}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth multiline rows={2}
              label="비고"
              size="small"
              name="rmk"
              value={formik.values.rmk}
              onChange={formik.handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">취소</Button>
        <Button onClick={formik.handleSubmit} variant="contained">저장</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AttendInputModal;
